import React from 'react';
import PropTypes from 'prop-types';
import { compose } from 'redux';
import { connect } from 'react-redux';
import { FormattedMessage, injectIntl, intlShape } from '../../util/reactIntl';
import { isScrollingDisabled } from '../../ducks/UI.duck';
import { TopbarContainer } from '../../containers';
import {
  Page,
  LayoutSideNavigation,
  LayoutWrapperMain,
  LayoutWrapperSideNav,
  LayoutWrapperTopbar,
  LayoutWrapperFooter,
  RefundPolicy,
  RefundPolicyEnglish, // Import the other component you want to conditionally render
  Footer,
} from '../../components';
import config from '../../config';

import css from './RefundPolicyPage.module.css';

const RefundPolicyPageComponent = props => {
  const { scrollingDisabled, intl } = props;
  const locale = intl.locale; // Extract the current locale

  const tabs = [
    {
      text: intl.formatMessage({ id: 'RefundPolicyPage.tosTabTitle' }),
      selected: false,
      linkProps: {
        name: 'TermsOfServicePage',
      },
    },
    {
      text: intl.formatMessage({ id: 'RefundPolicyPage.tsTabTitle' }),
      selected: false,
      linkProps: {
        name: 'ServicesFreePage',
      },
    },
    {
      text: intl.formatMessage({ id: 'RefundPolicyPage.pcTabTitle' }),
      selected: false,
      linkProps: {
        name: 'CancellationPolicyPage',
      },
    },
    {
      text: intl.formatMessage({ id: 'RefundPolicyPage.rpTabTitle' }),
      selected: true,
      linkProps: {
        name: 'RefundPolicyPage',
      },
    },
    {
      text: intl.formatMessage({ id: 'RefundPolicyPage.pcmTabTitle' }),
      selected: false,
      linkProps: {
        name: 'CausesPolicyPage',
      },
    },
    {
      text: intl.formatMessage({ id: 'RefundPolicyPage.usegTabTitle' }),
      selected: false,
      linkProps: {
        name: 'SeguroUupoPage',
      },
    },
    {
      text: intl.formatMessage({ id: 'RefundPolicyPage.segypTabTitle' }),
      selected: false,
      linkProps: {
        name: 'SecurityPriorityPage',
      },
    },
    {
      text: intl.formatMessage({ id: 'CommunicationSafetyPage.comunicationSafetyTabTitle' }),
      selected: false,
      linkProps: {
        name: 'CommunicationSafetyPage',
      },
    },
    {
      text: intl.formatMessage({ id: 'RefundPolicyPage.tpcdTabTitle' }),
      selected: false,
      linkProps: {
        name: 'TermProtectionPage',
      },
    },
    {
      text: intl.formatMessage({ id: 'RefundPolicyPage.hipdTabTitle' }),
      selected: false,
      linkProps: {
        name: 'ProtectionDataPage',
      },
    },
    {
      text: intl.formatMessage({ id: 'RefundPolicyPage.privacyTabTitle' }),
      selected: false,
      linkProps: {
        name: 'PrivacyPolicyPage',
      },
    },
    {
      text: intl.formatMessage({ id: 'RefundPolicyPage.pcookiesTabTitle' }),
      selected: false,
      linkProps: {
        name: 'CookiesPolicyPage',
      },
    },
  ];
  const siteTitle = config.siteTitle;
  const schemaTitle = intl.formatMessage({ id: 'RefundPolicyPage.schemaTitle' }, { siteTitle });
  const schema = {
    '@context': 'http://schema.org',
    '@type': 'WebPage',
    name: schemaTitle,
  };

  return (
    <Page title={schemaTitle} scrollingDisabled={scrollingDisabled} schema={schema}>
      <LayoutSideNavigation>
        <LayoutWrapperTopbar>
          <TopbarContainer currentPage="RefundPolicyPage" />
        </LayoutWrapperTopbar>
        <LayoutWrapperSideNav tabs={tabs} />
        <LayoutWrapperMain className={css.contentHeading}>
          <div className={css.content}>
            <h1 className={css.heading}>
              <FormattedMessage id="RefundPolicyPage.heading" />
            </h1>
            {locale === 'en-UK' ? <RefundPolicyEnglish /> : <RefundPolicy />}
          </div>
        </LayoutWrapperMain>
        <LayoutWrapperFooter>
          <Footer />
        </LayoutWrapperFooter>
      </LayoutSideNavigation>
    </Page>
  );
};

const { bool } = PropTypes;

RefundPolicyPageComponent.propTypes = {
  scrollingDisabled: bool.isRequired,

  // from injectIntl
  intl: intlShape.isRequired,
};

const mapStateToProps = state => {
  return {
    scrollingDisabled: isScrollingDisabled(state),
  };
};

const RefundPolicyPage = compose(connect(mapStateToProps), injectIntl)(RefundPolicyPageComponent);

export default RefundPolicyPage;
